'use client';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputField } from '../input-field/input-field';
import { containsAlphaChars, containsNumericChars } from './utils';

export const ACHName = ({ ...fieldProps }) => {
  const { getValues, setValue } = useFormContext();
  const { name } = fieldProps;
  const { t } = useTranslation(['checkout', 'payment-methods']);

  return (
    <InputField
      autoComplete="off"
      label={t('payment-methods:ach.fields.name')}
      onBlur={() => {
        setValue(name, getValues(name).trim(), {
          shouldValidate: true,
        });
      }}
      validate={(value: string) =>
        (containsAlphaChars(value) && !containsNumericChars(value)) ||
        t('checkout:form.ach.nameInvalid')
      }
      {...fieldProps}
    />
  );
};
